import {
  BookOpenText,
  ChartColumn,
  CircleDollarSign,
  Film,
  GraduationCap,
  NotepadText,
  Settings,
  SquarePen,
  Ticket,
  UserPlus,
  Users,
  WalletMinimal,
} from "lucide-react";
import { ReactElement } from "react";
import { useNavigate } from "react-router";
import {
  canCreateCodes,
  canCreateHomework,
  canCreateQuizzes,
  canEditLessons,
  canManageStudents,
  canPublishLessons,
  canViewHomeworkGrades,
  canViewQuizGrades,
  canViewSales,
  isAssistant,
  isProSubscription,
  isSubscribed,
  isTeacherOrAdmin,
} from "../../../hooks/utils";
import { useAppDispatch } from "../../../store/hooks";
import { pushModal } from "../../../store/slices/modalsSlice";
import SubscriptionCTA from "../../Modals/SubscriptionCTA";
import TutorWallet from "../../TutorWallet/TutorWallet";
import AssistantManagement from "../AssistantManagement/AssistantManagement";
import CouponManagement from "../CodeManagement/CodeManagement";
import CreateHomework from "../CreateHomework";
import CreateLessonWrapper from "../CreateLesson/CreateLessonWrapper";
import CreateQuiz from "../CreateQuiz";
import EditLesson from "../EditLesson";
import EditQuiz from "../EditQuiz";
import MainDashPage from "../MainDashPage/MainDashPage";
import ManageGrades from "../ManageGradesNew";
import ManageStudent from "../ManageStudent";
import QuestionBank from "../QuestionBank";
import QuizResults from "../QuizResults";
import TeacherSales from "../TeacherSales";

interface DashItemI {
  text: string;
  icon: ReactElement;
  component: ReactElement;
  id: string;
  slug: string;
  isFree: boolean;
}

export const dashboardItems = [
  {
    text: "الرئيسية",
    icon: <Settings className="size-5" />,
    component: <MainDashPage />,
    id: "mainDashPage",
    slug: "main",
    isFree: true,
    plan: 'free'
  },
  {
    text: "المحفظة",
    icon: <WalletMinimal className="size-5" />,
    component: <TutorWallet />,
    id: "tutorWallet",
    slug: "wallet",
    isFree: true,
    plan: 'free'
  },
  {
    text: "إدارة الأكواد",
    icon: <Ticket className="size-5" />,
    component: <CouponManagement />,
    id: "couponCreation",
    slug: "codes",
    isFree: true,
    plan: 'free'
  },
  {
    text: "الأقسام الدراسية",
    icon: <GraduationCap className="size-5" />,
    component: <ManageGrades />,
    id: "manageCats",
    slug: "manage-categories",
    isFree: true,
    plan: 'free'
  },
  {
    text: "نشر حصة جديدة",
    icon: <Film className="size-5" />,
    component: <CreateLessonWrapper />,
    id: "createLesson",
    slug: "create-lesson",
    isFree: true,
    plan: 'free'
  },
  {
    text: "تعديل حصة",
    icon: <SquarePen className="size-5" />,
    component: <EditLesson />,
    id: "editLesson",
    slug: "edit-lesson",
    isFree: true,
    plan: 'free'
  },
  {
    text: "إنشاء امتحان",
    icon: <NotepadText className="size-5" />,
    component: <CreateQuiz />,
    id: "createQuiz",
    slug: "create-quiz",
    isFree: false,
    plan: 'basic'
  },
  {
    text: "إنشاء واجب",
    icon: <NotepadText className="size-5" />,
    component: <CreateHomework />,
    id: "createHomework",
    slug: "create-homework",
    isFree: false,
    plan: 'basic'
  },
  {
    text: "تعديل امتحان/واجب",
    icon: <SquarePen className="size-5" />,
    component: <EditQuiz />,
    id: "editQuiz",
    slug: "edit-quiz",
    isFree: false,
    plan: 'basic'
  },
  {
    text: "مبيعات الحصص",
    icon: <CircleDollarSign className="size-5" />,
    component: <TeacherSales />,
    id: "teacherSales",
    slug: "sales",
    isFree: false,
    plan: 'basic'
  },
  {
    text: "نتائج الإمتحانات",
    icon: <ChartColumn className="size-5" />,
    component: <QuizResults />,
    id: "quizResults",
    slug: "results",
    isFree: false,
    plan: 'basic'
  },
  // {
  //   text: "إرسال إشعارات",
  //   icon: <Send className="size-5" />,
  //   component: <NotificationsDash />,
  //   id: "notifications",
  //   slug: "notifications",
  //   isFree: false,
  //   plan: 'basic'
  // },
  // {
  //   text: "تقارير الحضور و الغياب",
  //   icon: "bi bi-clipboard2-data",
  //   component: <AttendanceReports />,
  //   id: "attendanceReports",
  //   plan: 'free'
  // },
  {
    text: "إدارة الطلاب",
    icon: <Users className="size-5" />,
    component: <ManageStudent />,
    id: "manageStudent",
    slug: "manage-students",
    isFree: false,
    plan: 'basic'
  },
  {
    text: "بنك الأسئلة",
    icon: <BookOpenText className="size-5" />,
    component: <QuestionBank />,
    id: "questionBank",
    slug: "question-bank",
    isFree: false,
    plan: 'basic'
  },
  {
    text: "إدارة المساعدين",
    icon: <UserPlus className="size-5" />,
    component: <AssistantManagement />,
    id: "assistantManagement",
    slug: "assistant-management",
    isFree: false,
    plan: 'pro'
  },
  // {
  //   text: "إدارة مجاميع الأوفلاين",
  //   icon: "bi bi-gear",
  //   component: <ManageGroups />,
  //   id: "manageGroups",
  // },
  // {
  //   text: "الحضور و الغياب",
  //   icon: "bi bi-gear",
  //   component: <AttendanceDash />,
  //   id: "attendance",
  // },
];

const DashboardItems = ({ activeItem = "main" }: { activeItem: string }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleComponentChange = (slug) => {
    navigate(`/dashboard/${slug}`);
  };

  const isDisabled = (item: DashItemI) => {
    if (item.slug === "assistantManagement") return !isProSubscription();
    return isSubscribed() || item.isFree ? false : true;
  };

  // Check if an item should be visible based on user permissions
  const isItemVisible = (item: DashItemI) => {
    // Teachers and admins can see everything
    if (isTeacherOrAdmin()) {
      return true;
    }

    // For assistants, check specific permissions
    if (isAssistant()) {
      switch (item.id) {
        case "mainDashPage":
          return true; // Main page is always visible
        case "tutorWallet":
          return false; // Assistants cannot access wallet
        case "couponCreation":
          return canCreateCodes(); // Can access if has any code creation permission
        case "manageCats":
          return false; // Can view categories (filtered in the component)
        case "createLesson":
          return canPublishLessons(); // Can access if has any publish permission
        case "editLesson":
          return canEditLessons(); // Can access if has any edit permission
        case "createQuiz":
          return canCreateQuizzes();
        case "createHomework":
          return canCreateHomework();
        case "editQuiz":
          return canCreateQuizzes() || canCreateHomework(); // Can edit if can create either
        case "teacherSales":
          return canViewSales(); // Can access if has any sales view permission
        case "quizResults":
          return canViewQuizGrades() || canViewHomeworkGrades();
        case "manageStudent":
          return canManageStudents(); // Can access if has any student management permission
        case "questionBank":
          return canCreateQuizzes() || canCreateHomework(); // Can access if can create assessments
        case "assistantManagement":
          return false; // Assistants cannot manage other assistants
        default:
          return false;
      }
    }

    return false;
  };

  // Filter items based on visibility
  const visibleItems = dashboardItems.filter(isItemVisible);

  return (
    <>
      {visibleItems.map((item: DashItemI) => (
        <button
          key={item.id}
          onClick={() => {
            if (isDisabled(item)) {
              dispatch(pushModal(<SubscriptionCTA />));
              return;
            }
            handleComponentChange(item.slug);
          }}
          type="button"
          className={`w-full my-2 p-2 font-bold text-right flex items-center gap-2 text-sm hover:cursor-pointer ${
            !isSubscribed() && !item.isFree
              ? "bg-transparent opacity-25 rounded-ea border-0"
              : item.slug === activeItem
              ? "bg-(--secondary-color) text-(--primary-color-dark) rounded-ea border-0"
              : "bg-transparent rounded-ea border-0 text-white"
          }`}
        >
          {item.icon}
          {item.text}
        </button>
      ))}
    </>
  );
};

export default DashboardItems;
